import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiInputLabel = {
  styleOverrides: {
    root: {
      maxWidth: '100%',
      position: 'static',
      transform: 'none',
      color: 'var(--mui-palette-text-secondary)',
      fontSize: '0.8125rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
  },
} satisfies Components<Theme>['MuiInputLabel'];
